import axios from "axios"
import type { HttpAdapter } from "../core/adapters/axios.adapter"
import type { CompanyPeople, CompanyPeopleResult, Person, PersonResult } from "./person.models"

export class PersonService {
  constructor(private httpAdapter: HttpAdapter) {}

  /** GET /companies/:slug/people — members only (403 for Free). */
  async companyPeople(slug: string, lang: string): Promise<CompanyPeopleResult> {
    try {
      const url = `companies/${encodeURIComponent(slug)}/people?locale=${encodeURIComponent(lang)}`
      const response = await this.httpAdapter.get<CompanyPeople>(url)
      return { status: "ok", data: response.data }
    } catch (error) {
      const status = axios.isAxiosError(error) ? error.response?.status : undefined
      if (status === 403) return { status: "locked" }
      if (status === 404) return { status: "not_found" }
      console.error("[CompanyPeople] fetch failed", error)
      return { status: "error" }
    }
  }

  /** GET /people/:slug. `lang` picks the CMS locale (bio, headline) server-side. */
  async get(slug: string, lang: string): Promise<PersonResult> {
    try {
      const url = `people/${encodeURIComponent(slug)}?locale=${encodeURIComponent(lang)}`
      const response = await this.httpAdapter.get<Person>(url)
      return { status: "ok", person: response.data }
    } catch (error) {
      const status = axios.isAxiosError(error) ? error.response?.status : undefined
      if (status === 403) return { status: "locked" }
      if (status === 404) return { status: "not_found" }
      console.error("[PersonProfile] fetch failed", error)
      return { status: "error" }
    }
  }
}
